<script lang="ts">
  import type { Snippet } from "svelte"
  import { cn } from ".."
  import { getDialogRootContext } from "./DialogRoot.svelte"

  type Props = {
    class?: string
    children?: Snippet
    [key: string]: unknown
  }

  let { class: cssClass = "", children, ...restProps }: Props = $props()

  const rootCtx = getDialogRootContext()
</script>

<p
  class={cn("text-general-primary-text font-medium-400 leading-6", cssClass)}
  id={$rootCtx.descriptionId}
  {...restProps}
>
  {@render children?.()}
</p>
